import React, { useState } from "react";
import { Row, Col, Select, Radio, Space } from "antd";
import { InfoCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";

const { Option } = Select;

const Step3FormTemplate = ({
  wizardData,
  setWizardData,
  existingRegistrations,
  registrationID,
}) => {
  const handleTemplateChange = (e) => {
    const newData = {
      ...wizardData,
      formTemplateOption: e.target.value,
    };

    // Only clear copyFromRegistrationId if switching to default
    if (e.target.value === "default") {
      newData.copyFromRegistrationId = undefined;
    }

    console.log('Template changed:', e.target.value, 'copyFromRegistrationId:', newData.copyFromRegistrationId);
    setWizardData(newData);
  };

  const handleCopyFromChange = (value) => {
    console.log('Copy from changed:', value);
    setWizardData({
      ...wizardData,
      copyFromRegistrationId: value,
    });
  };

  return (
    <div className="wizard-step-card">
      <h3 className="wizard-step-title">Registration Form Setup</h3>
      <p className="wizard-step-description">
        Choose how you want to set up your registration form. You can start with
        our default template or copy the form from a previous registration.
      </p>

      <Radio.Group
        onChange={handleTemplateChange}
        value={wizardData.formTemplateOption}
        style={{ width: "100%" }}
      >
        <Space direction="vertical" style={{ width: "100%" }} size={16}>
          <div
            className={`wizard-template-option ${
              wizardData.formTemplateOption === "default" ? "selected" : ""
            }`}
          >
            <Radio value="default">
              <h4>
                <CheckCircleOutlined
                  style={{ color: "var(--mainColor)", marginRight: 8 }}
                />
                Use Default Template
              </h4>
            </Radio>
            <p style={{ marginLeft: 24, marginTop: 8 }}>
              Start with our pre-configured registration form that includes
              standard fields like participant name, age, contact information,
              and emergency contacts. This is perfect for most registration
              needs and can be customized later.
            </p>
            <div
              style={{
                marginLeft: 24,
                marginTop: 12,
                padding: 12,
                background: "#f5f5f5",
                borderRadius: 4,
                fontSize: 13,
              }}
            >
              <strong>Default fields include:</strong>
              <table style={{ marginTop: 8, marginBottom: 0, width: "100%", fontSize: 13 }}>
                <thead>
                  <tr style={{ textAlign: "left", borderBottom: "1px solid #ddd" }}>
                    <th style={{ padding: "4px 8px" }}>Field</th>
                    <th style={{ padding: "4px 8px", color: "#999" }}>reg_column_name</th>
                    <th style={{ padding: "4px 8px", color: "#999" }}>group_type</th>
                  </tr>
                </thead>
                <tbody>
                  <tr><td style={{ padding: "3px 8px" }}>First Name</td><td style={{ padding: "3px 8px", color: "#999" }}>camper_first_name</td><td style={{ padding: "3px 8px", color: "#999" }}>Participant Info</td></tr>
                  <tr><td style={{ padding: "3px 8px" }}>Last Name</td><td style={{ padding: "3px 8px", color: "#999" }}>camper_last_name</td><td style={{ padding: "3px 8px", color: "#999" }}>Participant Info</td></tr>
                  <tr><td style={{ padding: "3px 8px" }}>Birthday</td><td style={{ padding: "3px 8px", color: "#999" }}>camper_birthday</td><td style={{ padding: "3px 8px", color: "#999" }}>Participant Info</td></tr>
                  <tr><td style={{ padding: "3px 8px" }}>Grade</td><td style={{ padding: "3px 8px", color: "#999" }}>camper_grade</td><td style={{ padding: "3px 8px", color: "#999" }}>Participant Info</td></tr>
                  <tr><td style={{ padding: "3px 8px" }}>Parent First Name</td><td style={{ padding: "3px 8px", color: "#999" }}>p_first_name</td><td style={{ padding: "3px 8px", color: "#999" }}>Parent/Guardian Info</td></tr>
                  <tr><td style={{ padding: "3px 8px" }}>Parent Last Name</td><td style={{ padding: "3px 8px", color: "#999" }}>p_last_name</td><td style={{ padding: "3px 8px", color: "#999" }}>Parent/Guardian Info</td></tr>
                  <tr><td style={{ padding: "3px 8px" }}>Parent Email</td><td style={{ padding: "3px 8px", color: "#999" }}>p_email</td><td style={{ padding: "3px 8px", color: "#999" }}>Parent/Guardian Info</td></tr>
                  <tr><td style={{ padding: "3px 8px" }}>Parent Cell Phone</td><td style={{ padding: "3px 8px", color: "#999" }}>p_cell_phone</td><td style={{ padding: "3px 8px", color: "#999" }}>Parent/Guardian Info</td></tr>
                  <tr><td style={{ padding: "3px 8px" }}>Street</td><td style={{ padding: "3px 8px", color: "#999" }}>camper_street</td><td style={{ padding: "3px 8px", color: "#999" }}>Parent/Guardian Info</td></tr>
                  <tr><td style={{ padding: "3px 8px" }}>City</td><td style={{ padding: "3px 8px", color: "#999" }}>camper_city</td><td style={{ padding: "3px 8px", color: "#999" }}>Parent/Guardian Info</td></tr>
                  <tr><td style={{ padding: "3px 8px" }}>State</td><td style={{ padding: "3px 8px", color: "#999" }}>camper_state</td><td style={{ padding: "3px 8px", color: "#999" }}>Parent/Guardian Info</td></tr>
                  <tr><td style={{ padding: "3px 8px" }}>Zip</td><td style={{ padding: "3px 8px", color: "#999" }}>camper_zip</td><td style={{ padding: "3px 8px", color: "#999" }}>Parent/Guardian Info</td></tr>
                </tbody>
              </table>
            </div>
          </div>

          <div
            className={`wizard-template-option ${
              wizardData.formTemplateOption === "copy" ? "selected" : ""
            }`}
          >
            <Radio value="copy">
              <h4>
                <CheckCircleOutlined
                  style={{ color: "var(--mainColor)", marginRight: 8 }}
                />
                Copy From Existing Registration
              </h4>
            </Radio>
            <p style={{ marginLeft: 24, marginTop: 8, marginBottom: 12 }}>
              Use the exact form setup from one of your previous registrations.
              This will copy all custom fields, layout, and settings you
              previously configured.
            </p>

            {wizardData.formTemplateOption === "copy" && (
              <div style={{ marginLeft: 24, marginTop: 12 }}>
                <div style={{ fontWeight: 600, marginBottom: 8 }}>
                  Select Registration to Copy From{" "}
                  <span style={{ color: "red" }}>*</span>
                </div>
                <Select
                  showSearch
                  placeholder="Select a registration"
                  style={{ width: "100%", maxWidth: 500 }}
                  value={wizardData.copyFromRegistrationId}
                  onChange={handleCopyFromChange}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {existingRegistrations
                    .filter((reg) => reg.ID !== registrationID)
                    .map((reg) => (
                      <Option value={reg.ID} key={reg.ID}>
                        {reg.registration_name || `Registration ${reg.ID}`}
                      </Option>
                    ))}
                </Select>
                {existingRegistrations.filter(
                  (reg) => reg.ID !== registrationID
                ).length === 0 && (
                  <p
                    style={{
                      color: "#888",
                      fontSize: 13,
                      marginTop: 8,
                      fontStyle: "italic",
                    }}
                  >
                    No previous registrations available to copy from.
                  </p>
                )}
              </div>
            )}
          </div>
        </Space>
      </Radio.Group>

      <div className="wizard-info-box" style={{ marginTop: 24 }}>
        <p>
          <InfoCircleOutlined style={{ marginRight: 8 }} />
          Don't worry - you can customize the form fields after completing the
          wizard by editing the "Step 1 Form" tab in manual mode. The wizard is
          just getting you started quickly!
        </p>
      </div>
    </div>
  );
};

export default Step3FormTemplate;
